import { useState, useEffect } from "react";
import "../style/ner.scss"
import Divider from './common/Divider'
import Title from './common/Title'
import { dataLoader, Dropdown } from "@unbxd-ui/unbxd-react-components";
import nerDemoImg from "../common/images/ner_demo.svg";
import downArrow from "../common/images/down_arrow.png";
import searchIcon from "../common/images/search_icon.png";
import utils from "../common/utils";

export default function Ner() {
    const [searchVal, setSearchVal] = useState("Blue checks casual shirt");
    const [vertical, setVertical] = useState("apparel");
    const [nerResults, setNerResults] = useState({});
    const [verticalClass, setVerticalClass] = useState("close");
    const [selectedTag, setSelectedTag] = useState(searchVal);
    const [error,setError] = useState("");
    const [ isLoading, setIsLoading ] = useState(false);

    useEffect(() => {
        onSearchClick(null, searchVal);
    }, []);
    
    const validate = (val) =>{
        if(val.length === 0){
            setError("Input cannot be empty");
            return false;
        }else{
            setError("");
            return true;
        }
    }

    const onSearchValChange = (event) => {
        setSearchVal(event.target.value);
    }

    const onSearchClick = (event, val) => {
        if(validate(val || searchVal)){
            setIsLoading(true);
            const def = dataLoader.getRequestDef({
            requestId: "getNerResults",
            urlParams: {
                vertical
            },
            params: {
                q: val || searchVal
            }
        })
        
        def.done(response => {
            const { data = {},errors=[] } = response;
            const { tags = [] } = data;
            const updatedTags = {};
            setIsLoading(false);
            if (errors && errors.length) {
                //setError here
                return;
            }
            
            tags.forEach((tag) => {
                const { label, phrase } = tag;
                if (updatedTags[label]) {
                    updatedTags[label].push(phrase);
                } else {
                    updatedTags[label] = [phrase];
                }
            })
            setNerResults(updatedTags);
        });
        
        def.catch((error) => {
            setIsLoading(false);
            setError(error);
            console.log(error);
        });
        }        
        
    }

    const onVerticalChange = (event) => {
        let vertical = event.target.innerText.toLowerCase();
        vertical = vertical.replace(/&/g, '').replace(/\s/g, '_');
        setVertical(vertical);
        closeVerticalDD();
    }

    const onSampleQueryClick = (val) => {
        setSelectedTag(val)
        setSearchVal(val);
        onSearchClick(null, val);
    }

    const toggleVerticalDD = () => {
        if (verticalClass === "close") {
            setVerticalClass("open");
        } else {
            setVerticalClass("close");
        }
    }

    const closeVerticalDD = () => {
        setVerticalClass("close");
    }

    const APPAREL_VERTICAL_QUERY_TAGS = [
        'Blue checks casual shirt',
        'Black shirt for men',
        'Red floral print gown for women',
        'Red print suit for men',
        'Blue dress shirt'
    ];

    const HOME_VERTICAL_QUERY_TAGS = [
        'Round dining room table sets',
        'Queen memory foam mattress',
        'White dresser and mirror',
        'Leather bar stool',
        'Outdoor swivel chair'
    ];

    const BEAUTY_VERTICAL_QUERY_TAGS = [
        'Herbal Hydrating Serum',
        'Vitamin E Body Lotion',
        'Body wash acne',
        'Glycolic acid toner green',
        'Face moisturiser'
    ];

    const LIQUOR_VERTICAL_QUERY_TAGS = [
        'Single malt Scotch Whisky',
        'Brown brothers moscato',
        'Somersby apple cider',
        'Jacobs Creek Pinot Grigio'
    ];

    const FOOD_VERTICAL_QUERY_TAGS = [
        'Gluten free peanut butter',
        'Organic Honeydew Melon',
        'Cookie dough',
        'Salad dressing',
        'Banana joe chips'
    ]

    const PETS_VERTICAL_QUERY_TAGS = [
        'Canidae Ragdoll Cat Dog Toys',
        'Royal Canin Staffy Gluten Free Food',
        'Nutro Pomeranian Organic Dental Treats',
        'Natural Balance Burmese Cat Shampoos'
    ]

    const queriesMap = {
        "apparel": APPAREL_VERTICAL_QUERY_TAGS,
        "home": HOME_VERTICAL_QUERY_TAGS,
        "beauty": BEAUTY_VERTICAL_QUERY_TAGS,
        "liquor": LIQUOR_VERTICAL_QUERY_TAGS,
        "food" : FOOD_VERTICAL_QUERY_TAGS,
        "pets_supplies": PETS_VERTICAL_QUERY_TAGS
    }

    return (
        <div className="columns highlight-info sticky-hexagon-reverse">
            <div className="column col-xl-12 col-6 highlight-content-left ">
                <div className="content-wrap">
                    <Title title="Named Entity Recognition" showBadge={false} className="mb-2 sub-title title" />
                    <div className="feature-description desc col-xl-12 col-12">One of the most common ways to understand query intent is Named Entity Recognition (NER, as we call it). NER enables us to perform contextual query expansion which can be then fed to our search engine for culling out a more precise and relevant set of results as compared to the traditional query expansion. </div>
                    <div className="spin">Try Your Query</div>
                    <div className="select-vertical mb-1">Select the vertical<span className="mandatory">*</span></div>
                    <div className="vertical-dd-container">
                        <div className="vertical-dd" onClick={toggleVerticalDD}>
                            <span className="vertical-dd-label">{utils.capitalize(vertical)}</span>
                            <img className="down-arrow-img" src={downArrow}></img>
                        </div>
                        <ul className={`vertical-dd-list ${verticalClass}`} onClick={onVerticalChange}>
                            <li className={`vertical-dd-list-item`}>Apparel</li>
                            <li className={`vertical-dd-list-item`}>Home</li>
                            <li className={`vertical-dd-list-item`}>Food</li>
                            <li className={`vertical-dd-list-item`}>Beauty</li>
                            <li className={`vertical-dd-list-item`}>Liquor</li>
                            <li className={`vertical-dd-list-item`}>Pets_supplies</li>
                        </ul>
                    </div>
                    <div className="search-container">
                        <div className="search-input-container">
                            <input type="text" value={searchVal} placeholder="Enter A Query" className="search-input" onChange={onSearchValChange} />
                            <img src={searchIcon} className="search-img" />
                        </div>
                        <button onClick={onSearchClick} className="search-button">Preview</button>
                    </div>
                    {error && <div className="api-error entity-extraction">{error}</div>}
                    <div className="spin">Try Sample Queries</div>
                    <div className="sample-queries-container">{queriesMap[vertical].map((item) => {
                        return (
                            <span className={`sample-queries-tags ${selectedTag === item ? 'sample-query-highlight' : ""}`} title={item} onClick={onSampleQueryClick.bind(null, item)}>{item} </span>
                        )
                    })}</div>
                </div>
            </div>

            <div className="column col-xl-12 col-6">
                <div className="content-wrap">
                    <div className="ner-results-wrapper">
                        <img src={nerDemoImg} className="ner-demo-img" />
                            
                        {!error && !isLoading && Object.keys(nerResults).length? 
                            <div className="ner-results-table text-center">
                                <div className="demo-table-header columns">
                                    <div className="column">{`Entities`}</div>
                                    <div className="column">{`Values`}</div>
                                </div>
                                <div>
                                    {
                                    Object.keys(nerResults).map((tag) => {
                                        return (
                                            <div className="demo-table-data columns">
                                                    <div className="column">{utils.capitalize(tag.toLowerCase())}</div>
                                                    <div className="column">{nerResults[tag].join(", ")}</div>
                                            </div>
                                        )
                                        })
                                    }
                                </div>
                            </div>   
                            :
                            "" 
                        }
                        {isLoading && <img className="ner-loading-icon" src={"/images/blueLoader.svg"} />}
                        
                    </div>
                    {/* <Dropdown /> */}
                </div>
            </div>

        </div>
    )
}
